import { Component, OnInit } from '@angular/core';
import { LocalDataSource } from 'ng2-smart-table';
import * as moment from 'moment';
import { NotifierService } from '../../shared/notifier/notifier.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material';
import { AlertComponent } from '../../../shared';
import 'rxjs/add/operator/filter';
import * as fileSaver from 'file-saver';
import { ClientService } from '../../services/client.service';
import { BillingService } from '../../services/billing.service';
import { ReportesService } from '../../services/reportes.service';
import { CxcService } from '../../services/cxc.service';
import { CurrencyPipe } from '@angular/common';
import { ReportBillingDetailComponent } from '../report-billing-detail/report-billing-detail.component';
@Component({
  selector: 'app-billing-list',
  templateUrl: 'billing-list.component.html',
  styleUrls: ['billing-list.component.scss'],
  providers: [BillingService, ReportesService, CxcService, ClientService],
})
export class BillingListComponent implements OnInit {
  tableSettingsBudgetHeader: any = undefined;
  dataSourceBudgetHeader: any = undefined;
  tableDataBudgetHeader: any = {};
  params: any = {};
  currentId: number;
  perPage = 10;
  all_active = true;
  billed = false;
  to_bill = false;

  totalfacturado = 0;
  stringtotalfacturado;

  customDatesReport: any = {};
  filtroyear;
  filtrocliente;
  filtronombrecliente;
  clientListar: Array<any>;
  yearListar: Array<any>;

  cancelled = false;
  settings = {
    pager: { display: true, perPage: this.perPage },
    noDataMessage: 'No hay datos que mostrar.', columns: undefined,
    actions: {
      add: false, delete: false, position: 'right', edit: false, columnTitle: 'Acciones',
      custom: [
        { name: 'PDF', title: `<div class="editCustomButton">PDF</div>` },
        { name: 'XML', title: `<div class="editCustomButton">XML</div>` },
        { name: 'anular', title: `<div class="editCustomButton">Anular</div>` }
      ]
    }
  };
  data: any = [];
  labels: any = [];
  type: string = 'bar';
  totalsoles = 0;
  totaldolares = 0;
  tipomoneda = '';
  options: any = {
    animation: {
      duration: 0,
      onComplete: function () {
        var ctx = this.chart.ctx;
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        var chart = this;
        var datasets = this.config.data.datasets;
        datasets.forEach((dataset: Array<any>, i: number)=>{
          ctx.font = "10px Arial";
          ctx.fillStyle = "white";
          chart.getDatasetMeta(i).data.forEach((p: any, j: any)=>{

            ctx.fillText(new CurrencyPipe('en_US').transform(datasets[i].data[j],'S/ '), p._model.x, p._model.y+25);
          });

        });
      }
    },
    scales: {
      yAxes: [{
        scaleLabel: {
          display: true,
          labelString: 'Total Facturado (S/)', 
        },
        ticks: {
          beginAtZero: true
        }
      }],
      xAxes: [{
        scaleLabel: {
          display: true,
          labelString: 'Mes - Año'
        }
      }]
    }
  };
  colors: any = ['#fecc00'];
  clientData: any = {};
  clientList: any = [];
  monthIni: any;
  yearIni: any;
  monthEnd: any;
  yearEnd: any;
  filteredOptions1 = '';

  monthList: any = [
    { number: 0, text: 'Enero'},
    { number: 1, text: 'Febrero'},
    { number: 2, text: 'Marzo'},
    { number: 3, text: 'Abril'},
    { number: 4, text: 'Mayo'},
    { number: 5, text: 'Junio'},
    { number: 6, text: 'Julio'},
    { number: 7, text: 'Agosto'},
    { number: 8, text: 'Septiembre'},
    { number: 9, text: 'Octubre'},
    { number: 10, text: 'Noviembre'},
    { number: 11, text: 'Diciembre'},
  ]
  showGraphicator: boolean = false;
  showGraph: boolean = false;
  now: Date;
  constructor(
    private billingService: BillingService,
    private activedRoutes: ActivatedRoute,
    private cxcpaymentService: CxcService,
    private routes: Router,
    private dialog: MatDialog,
    private clientService: ClientService,
    private notifierService: NotifierService,
    private reporteService: ReportesService,
  ) {


    this.clientService.getClientListBilling().subscribe((result: Array<any>) => {
      this.clientListar = result;
      
  }, (error) => {
      this.notifierService.systemNotify({
          title: 'Error',
          message: error.message,
          type: 'error'
      });
  })

  this.billingService.getYearBilling().subscribe((result: Array<any>) => {
    this.yearListar = result;
    
}
);
    this.now = new Date();
    this.monthIni = this.now.getMonth();
    this.monthEnd = this.now.getMonth();
    this.yearIni = this.now.getFullYear();
    this.yearEnd = this.now.getFullYear();
    this.params = this.activedRoutes.params;
    this.tableDataBudgetHeader = {
      columns: {
        budget_header: { title: 'Presupuesto' },
        total: { title: 'Total' },
        payment_terms: { title: 'Terminos de Pago' },
        tipo_doc: { title: 'Tipo Doc.' },
        doc_number: { title: 'Numero de Doc.' },
        doc_date_f: { title: 'Fecha de Doc.' },
        expired_date: { title: 'Fecha de Expiración' }
      },
      data: {}
    };
  }

  ngOnInit() {
    this.loadAllBilled();
  }

  getClientes(event?) {
    if (event) {
        this.filteredOptions1 = event.target.value
    }
    this.clientService.getClientByName(this.filteredOptions1.replace(/ /g, ""))
        .subscribe(
            result => {
                this.clientListar = result as Array<any>
                this.filtrocliente = this.clientListar[0].id;
                console.log( this.customDatesReport.encargado_id);

            },
            error => {
                console.log('error', error)
            }
        )
}

onClientSelected(selectedUsuario) {
  this.filtrocliente = selectedUsuario.id;
}


calcularReporte(){

  this.billingService.getBillingFilterClient( this.filtrocliente, this.filtroyear).subscribe((result: Array<any>) => {
    this.notifierService.systemNotify({
      title: 'Éxito',
      message: 'Reporte calculado de '+ this.filtronombrecliente+ ' del año '+this.filtroyear,
      type: 'success'
    });
    this.getTableData(result);

  }, (error) => {
    this.notifierService.systemNotify({
      title: 'Ha ocurrido un error',
      message: 'No hay reporte de '+this.filtronombrecliente+ ' del año '+this.filtroyear,
      type: 'error'
    });
    this.getTableData([]);
  });
}
  loadAll() {
    this.settings = {
      pager: { display: true, perPage: this.perPage },
      noDataMessage: 'No hay datos que mostrar.', columns: undefined,
      actions: {
        add: false, delete: false, position: 'right', edit: false, columnTitle: 'Acciones',
        custom: [
          { name: 'PDF', title: `<div class="editCustomButton">PDF</div>` },
          { name: 'XML', title: `<div class="editCustomButton">XML</div>` },
          { name: 'CDR', title: `<div class="editCustomButton">CDR</div>` },
          { name: 'anular', title: `<div class="editCustomButton">Anular</div>` }
        ]
      }
    };
    this.all_active = true;
    this.billed = false;
    this.to_bill = false;
    this.cancelled = false;
    this.billingService.getBilling().subscribe((result: Array<any>) => {
      this.getTableData(result);
    }, (error) => {
      this.getTableData([]);
    });
  }

  loadAllBilled() {
    this.settings = {
      pager: { display: true, perPage: this.perPage },
      noDataMessage: 'No hay datos que mostrar.', columns: undefined,
      actions: {
        add: false, delete: false, position: 'right', edit: false, columnTitle: 'Acciones',
        custom: [
          { name: 'PDF', title: `<div class="editCustomButton">PDF</div>` },
          { name: 'XML', title: `<div class="editCustomButton">XML</div>` },
          { name: 'CDR', title: `<div class="editCustomButton">CDR</div>` },
          { name: 'anular', title: `<div class="editCustomButton">Anular</div>` }
        ]
      }
    };
    this.all_active = false;
    this.billed = true;
    this.to_bill = false;
    this.cancelled = false;
    this.billingService.getBillingFilter(1).subscribe((result: Array<any>) => {
      this.getTableData(result);
    }, (error) => {
      this.getTableData([]);
    });
  }

  loadAllToBill() {
    this.settings = {
      pager: { display: true, perPage: this.perPage },
      noDataMessage: 'No hay datos que mostrar.', columns: undefined,
      actions: {
        add: false, delete: false, position: 'right', edit: false, columnTitle: 'Acciones',
        custom: [
          { name: 'PDF', title: `<div class="editCustomButton">PDF</div>` },
          { name: 'XML', title: `<div class="editCustomButton">XML</div>` },
          { name: 'CDR', title: `<div class="editCustomButton">CDR</div>` },
          { name: 'anular', title: `<div class="editCustomButton">Anular</div>` }
        ]
      }
    };
    this.all_active = false;
    this.billed = false;
    this.to_bill = true;
    this.cancelled = false;
    this.billingService.getBillingFilter(2).subscribe((result: Array<any>) => {
      this.getTableData(result);
    }, (error) => {
      this.getTableData([]);
    });
  }

  loadAllCancelled() {
    this.settings = {
      pager: { display: true, perPage: this.perPage },
      noDataMessage: 'No hay datos que mostrar.', columns: undefined,
      actions: {
        add: false, delete: false, position: 'right', edit: false, columnTitle: 'Acciones',
        custom: [
          { name: 'PDF', title: `<div class="editCustomButton">PDF</div>` },
          { name: 'XML', title: `<div class="editCustomButton">XML</div>` },
          { name: 'Baja', title: `<div class="editCustomButton">PDF Baja</div>` }

        ]
      }
    };
    this.all_active = false;
    this.billed = false;
    this.to_bill = false;
    this.cancelled = true;
    this.billingService.getBillingFilter(3).subscribe((result: Array<any>) => {
      this.getTableData(result);
    }, (error) => {
      this.getTableData([]);
    });
  }

  copyObject(obj): object {
    return JSON.parse(JSON.stringify(obj));
  }

  async getTableData(result) {
    this.totalsoles=0;
    this.totaldolares=0;
    this.tipomoneda='';
    for (const r of result) {
      r.doc_date_f =
        r.doc_date_f.split('T')[0].split('-')[2]
        + '-' +
        r.doc_date_f.split('T')[0].split('-')[1]
        + '-' + r.doc_date_f.split('T')[0].split('-')[0];
      if (r.expired_date) {
        r.expired_date =
          r.expired_date.split('T')[0].split('-')[2]
          + '-' +
          r.expired_date.split('T')[0].split('-')[1]
          + '-' + r.expired_date.split('T')[0].split('-')[0];
      }
      if(r.currency === 7){
        this.totalsoles = this.totalsoles + r.total;
      }
      else{
        this.totaldolares = this.totaldolares + r.total;
      }
      
      
      this.tipomoneda = r.currency === 7 ? 'S/.' : 'USD ';

      r.total = this.tipomoneda + Number(r.total).toFixed(2);
    }
    console.log(this.totalsoles.toFixed(2));
    console.log(this.totaldolares.toFixed(2));
    const cloneRows: Array<any> = [...result];
    //console.log(cloneRows);

    this.dataSourceBudgetHeader = new LocalDataSource(cloneRows);
    this.tableSettingsBudgetHeader = this.copyObject(this.settings);
    // this.tableSettingsBudgetHeader.columns.work_order_external_code.filter=false;

    if (this.tableDataBudgetHeader.columns !== undefined) {
      this.tableSettingsBudgetHeader.columns = this.copyObject(this.tableDataBudgetHeader.columns);
      // Se deshabilita los filtros predefinidos para evitar conflictos

      this.tableSettingsBudgetHeader.columns["total"] = {
        "title": this.tableSettingsBudgetHeader.columns["total"].title, type: 'html', valuePrepareFunction: function (value) {
          return '<div class="numberformat" style="text-align:right"> ' + value + ' </div>'
        }
      };

      Object.keys(this.tableSettingsBudgetHeader.columns).forEach(key => {
        this.tableSettingsBudgetHeader.columns[key].filter = true;
      });
    }


    
    if (localStorage.getItem('filter-billing') != '' && localStorage.getItem('filter-billing') ){

      var elem = JSON.parse(localStorage.getItem('filter-billing') );
      
      if (cloneRows.length > 0){
        console.log('ww',cloneRows.length )
        this.dataSourceBudgetHeader.setFilter(elem.filters);
        localStorage.setItem('filter-billing', '');
      }
      
    }
    
    
  }

  customAction(event) {
    switch (event.action) {
      case 'PDF':
        //window.open(event.data.url_pdf);

        /////////////////////////////////////////////////
        
        this.notifierService.systemNotify({
          title: 'Espere un momento',
          message: 'Descargando PDF',
          type: 'info',
          duration: 20000
        });

        this.billingService.getPDF(event.data).subscribe((result: any) => {
          const filename = 'Factura_'+event.data.doc_number+'.pdf';
          fileSaver.saveAs(result, filename);
          this.notifierService.systemNotify({
            title: 'Exito',
            message: 'Se ha descargado el PDF.',
            duration: 5000,
            type: 'success'
          });
        },
        error => {
          console.log(error);
          this.notifierService.systemNotify({
            title: 'Error',
            message: 'Ha ocurrido un error al descargar el PDF',
            type: 'error',
            duration: 5000
          });
        });
        
        break;
      case 'Baja':

        this.notifierService.systemNotify({
          title: 'Espere un momento',
          message: 'Descargando PDF',
          type: 'info',
          duration: 20000
        });

        this.billingService.getBajaPDF(event.data).subscribe((result: any) => {
          const filename = 'Baja_'+event.data.doc_number+'.pdf';
          fileSaver.saveAs(result, filename);
          this.notifierService.systemNotify({
            title: 'Exito',
            message: 'Se ha descargado el PDF.',
            duration: 5000,
            type: 'success'
          });
        },
        error => {
          console.log(error);
          this.notifierService.systemNotify({
            title: 'Error',
            message: 'Ha ocurrido un error al descargar el PDF',
            type: 'error',
            duration: 5000
          });
        });
        break;

      case 'XML':
        window.open(event.data.url_xml);
        break;
        case 'CDR':
          var urlXDR = event.data.url_xml.replace('.xml','.cdr');
          window.open(urlXDR);
          break;
      case 'anular':
        var createDate = new Date(event.data.doc_date.split('-')[2],Number(event.data.doc_date.split('-')[1]) - 1,event.data.doc_date.split('-')[0]).getTime();
        var justNow = new Date().getTime();

        var diffTime = justNow - createDate;
        var diffDays = Math.ceil(diffTime / (24 * 3600 * 1000)); //transform miliseconds to days

        if (diffDays > 3) {
          const infoDialog = this.dialog.open(AlertComponent, {
            data: {
              icon: 'exclamation-circle',
              iconColor: 'failure',
              title: 'Operación invalida',
              text: 'Solo se puede anular facturas hasta 3 días después de haber sido generadas',
              options: false
            }
          });
        } else {
          const deleteDialog = this.dialog.open(AlertComponent, {
            data: {
              icon: 'exclamation-circle',
              iconColor: 'failure',
              title: 'Aviso',
              text: '¿Está seguro que desea anular la factura?',
              options: true
            }
          });
          deleteDialog.afterClosed().subscribe((result) => {
            if (result) {
              this.notifierService.systemNotify({
                title: 'Espere',
                message: 'Anulando Factura',
                type: 'info',
                duration: 20000
              });
              // service delete
              //console.log("event",event);
              let data = {
                idInnoceAnulate: event.data.id_pronos_bill,
                comentary: ''
              }
              //console.log("data",data);
              this.cxcpaymentService.anulateInnvoce(data).subscribe((anulateResult) => {
                this.billingService.anulateBill(event.data.id).subscribe((anulateBill) => {
                  this.notifierService.systemNotify({
                    title: 'Exito',
                    message: 'Se anulo correctamente la factura',
                    type: 'success'
                  });
                  this.loadAll();
                }, (error) => {
                  this.notifierService.systemNotify({
                    title: 'Error',
                    message: 'Ha ocurrido un error al anular la factura',
                    type: 'error',
                    duration: 5000
                  });
                });
              }, (error) => {
                this.notifierService.systemNotify({
                  title: 'Error',
                  message: 'Ha ocurrido un error al anular la factura',
                  type: 'error',
                  duration: 5000
                });
              });
            }
          }, (error) => {
            console.log('error', error);
          });
          break;
        }
    }
  }
  exportExcel() {
    let headerData;
    let copyData;

    headerData = [
      { dataBound: 'budget_header', name: 'Presupuesto', width: 40 },
      { dataBound: 'total', name: 'Total', width: 20 },
      { dataBound: 'payment_terms', name: 'Terminos de Pago', width: 30 },
      { dataBound: 'doc_number', name: 'Numero de Doc.', width: 30 },
      { dataBound: 'doc_date_f', name: 'Fecha de Doc.', width: 30 },
      { dataBound: 'expired_date', name: 'Fecha de Expiración', width: 30 }];
    copyData = this.dataSourceBudgetHeader.filteredAndSorted;
    this.reporteService.exportExcelBilling(headerData, copyData, this.totalsoles, this.totaldolares).subscribe(result => {
      const mediaType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      const blob = new Blob([result._body], { type: mediaType });
      const fileName = 'Reporte';
      fileSaver.saveAs(blob, fileName);
    });
  }

  exportReportBilling() {

    this.reporteService.exportReportBilling().subscribe(result => {
      const mediaType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      const blob = new Blob([result._body], { type: mediaType });
      const fileName = 'Reporte';
      fileSaver.saveAs(blob, fileName);
    });
  }

  showGraphicatorModule(){

    localStorage.setItem('filter-billing' ,JSON.stringify(this.dataSourceBudgetHeader.getFilter()));

    this.billingService.getBillingClients().subscribe(
      (result)=>{
        this.clientList = result;
        this.monthIni = this.now.getMonth();
        this.monthEnd = this.now.getMonth();
        this.yearIni = this.now.getFullYear();
        this.yearEnd = this.now.getFullYear();
        this.clientData = {};
        this.showGraphicator = true;
      },
      (error)=>{
        console.log(error);
      }
    )
  }

  hideGraphicatorModule(){
    this.showGraphicator = false;
  }

  showGraphModule(){
    if(Object.keys(this.clientData).length !== 0){
      var dateIni = new Date(this.yearIni,this.monthIni)
      var dateEnd = new Date(this.yearEnd,this.monthEnd)
      var dateEndF = new Date(this.yearEnd,this.monthEnd)

      if(dateIni.getTime() <= dateEnd.getTime()){
        var monSol  = new Date(dateEndF.setMonth(dateEndF.getMonth()+1));
        var curMon = monSol.getMonth() +1;
        var curYear = monSol.getFullYear();

        var strDateIni = this.yearIni+'-'+(parseInt(this.monthIni)+1)+'-01';
        var strDateEnd =curYear +'-'+(curMon)+'-01'; 
        this.billingService.getBillingGraph(this.clientData.id, strDateIni, strDateEnd).subscribe(
          (result: any)=>{
            console.log(result);
            this.totalfacturado = 0;
            (result.data).forEach(element => {
              this.totalfacturado = this.totalfacturado + Number(element);
            });
            this.stringtotalfacturado = this.totalfacturado.toLocaleString();
            this.options.title = {text: this.clientData.name + ' - Facturación', display: true, fontSize: 25,};
            this.data = [{ data: result.data, label: 'Total Facturado' , backgroundColor: '#fecc00', borderWidth: 1}] ;
            this.labels = result.labels;
            this.showGraph = true;


            
            
            
            console.log(this.totalfacturado);
            console.log(result.data);
          },
          (error)=>{
            console.log(error)
          }
        )
        
      }else{
        this.notifierService.systemNotify({
          title: 'Error',
          message: 'El periodo es incorrecto.',
          type: 'error'
        });
      }
    }else{
      this.notifierService.systemNotify({
        title: 'Error',
        message: 'No se ha elegido un cliente.',
        type: 'error'
      });
    }
  }

  hideGraphModule(){
    this.showGraph = false;
  }

  exportGraphModule(event){
    var anchor = event.target;
    anchor.href = document.getElementsByTagName('canvas')[0].toDataURL();
    anchor.download = this.clientData.name + '-Facturacion.png';
  }

  openModalForGenerateBillingDetailReport() {
    const data = {
      clients: this.clientListar
    }
    this.dialog.open(ReportBillingDetailComponent, {
      data
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/system/billing/billing-list/billing-list.component.ts